import React from 'react';
import { CalendarDays, Clock } from 'lucide-react';
import { VisitaGuiada } from '../../../domain/entities/VisitaGuiada';
import { APP_CONFIG } from '../../../shared/constants/AppConfig';
import { GoogleCalendarButton } from '../GoogleCalendarButton';

interface VisitaGuiadaCardProps {
  visita: VisitaGuiada;
  compact?: boolean;
}

export const VisitaGuiadaCard: React.FC<VisitaGuiadaCardProps> = ({ visita, compact }) => {
  const title = `${APP_CONFIG.ORGANIZATION_NAME} - Visita Guiada`;
  const description = 'Participe da visita guiada!';
  const startDate = new Date(visita.date.value);
  const [hours, minutes] = visita.time.value.split(':');
  startDate.setHours(Number(hours), Number(minutes), 0, 0);
  const endDate = new Date(startDate.getTime() + 30 * 60 * 1000);

  function formatDateForGoogle(date: Date) {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  }

  const dates = `${formatDateForGoogle(startDate)}/${formatDateForGoogle(endDate)}`;
  const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${dates}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(APP_CONFIG.ADDRESS)}`;

  if (compact) {
    return (
      <div className="flex items-center justify-between gap-4 p-3 bg-card rounded-md border text-sm">
        <div className="flex items-center gap-3 text-muted-foreground">
          <span className="flex items-center gap-1">
            <CalendarDays size={13} className="text-accent" />
            {visita.getFormattedDate()}
          </span>
          <span className="flex items-center gap-1">
            <Clock size={13} className="text-accent" />
            {visita.getWeekday()}, {visita.time.value}
          </span>
        </div>
        <GoogleCalendarButton url={googleCalendarUrl} />
      </div>
    );
  }

  return (
    <div className="p-5 bg-card rounded-lg border hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-base text-primary mb-1">{visita.getFormattedDate()}</h3>
          <p className="text-sm text-muted-foreground">{visita.getWeekday()}, {visita.time.value}</p>
        </div>
        <GoogleCalendarButton url={googleCalendarUrl} />
      </div>
    </div>
  );
};
